var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignupStep1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Steeper/01 Create Account") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 -1.77635684e-15 19.9998 -1.77635684e-15 19.9998 12.333 0 12.333"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 19.9998 0 19.9998 12.351 0 12.351"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Steeper/01-Create-Account",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000200, 7.666600)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.22,12.333 L3.779,12.333 C1.695,12.333 0,10.637 0,8.554 L0,1 C0,0.447 0.447,-1.77635684e-15 1,-1.77635684e-15 C1.553,-1.77635684e-15 2,0.447 2,1 L2,8.554 C2,9.535 2.798,10.333 3.779,10.333 L16.22,10.333 C17.202,10.333 18,9.535 18,8.554 L18,7.69 C18,7.137 18.447,6.69 19,6.69 C19.553,6.69 20,7.137 20,7.69 L20,8.554 C20,10.637 18.304,12.333 16.22,12.333",
    id: "Fill-1",
    fill: "current"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9998,12.351 C18.4468,12.351 17.9998,11.904 17.9998,11.351 L17.9998,3.778 C17.9998,2.798 17.2018,2 16.2198,2 L3.7788,2 C2.7978,2 1.9998,2.798 1.9998,3.778 L1.9998,4.668 C1.9998,5.221 1.5528,5.668 0.9998,5.668 C0.4468,5.668 -0.0002,5.221 -0.0002,4.668 L-0.0002,3.778 C-0.0002,1.695 1.6958,0 3.7788,0 L16.2198,0 C18.3048,0 19.9998,1.695 19.9998,3.778 L19.9998,11.351 C19.9998,11.904 19.5528,12.351 18.9998,12.351",
    id: "Fill-4",
    fill: "current"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.744,8.1828 C15.404,7.8428 14.849,7.8428 14.509,8.1828 L12.67,10.0188 L12.126,9.5768 C11.949,9.4328 11.721,9.3658 11.484,9.3848 C11.247,9.4108 11.038,9.5248 10.896,9.7058 C10.748,9.8868 10.681,10.1148 10.705,10.3468 C10.73,10.5808 10.843,10.7898 11.024,10.9358 L12.177,11.8718 C12.324,11.9938 12.503,12.0618 12.695,12.0688 C12.707,12.0698 12.72,12.0698 12.733,12.0698 C12.963,12.0698 13.186,11.9778 13.35,11.8148 L15.746,9.4208 C16.086,9.0808 16.086,8.5258 15.744,8.1828",
    id: "Fill-7",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2126,4.9783 L4.9986,4.9783 C4.4466,4.9783 3.9986,5.4253 3.9986,5.9783 C3.9986,6.5313 4.4466,6.9783 4.9986,6.9783 L8.2126,6.9783 C8.7656,6.9783 9.2126,6.5313 9.2126,5.9783 C9.2126,5.4253 8.7656,4.9783 8.2126,4.9783",
    id: "Fill-9",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2126,8.9994 L4.9986,8.9994 C4.4466,8.9994 3.9986,9.4464 3.9986,9.9994 C3.9986,10.5524 4.4466,10.9994 4.9986,10.9994 L8.2126,10.9994 C8.7656,10.9994 9.2126,10.5524 9.2126,9.9994 C9.2126,9.4464 8.7656,8.9994 8.2126,8.9994",
    id: "Fill-11",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2126,13.0205 L4.9986,13.0205 C4.4466,13.0205 3.9986,13.4675 3.9986,14.0205 C3.9986,14.5735 4.4466,15.0205 4.9986,15.0205 L8.2126,15.0205 C8.7656,15.0205 9.2126,14.5735 9.2126,14.0205 C9.2126,13.4675 8.7656,13.0205 8.2126,13.0205",
    id: "Fill-13",
    fill: "current"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupStep1);
export default __webpack_public_path__ + "static/media/signup-step-1.cd73ea1b02939b5cae173588fd4e2542.svg";
export { ForwardRef as ReactComponent };